import { useTranslate } from '@refinedev/core';
import { Flex, Typography, theme } from 'antd';
import { PublisherContextSwitcher } from '@/components/content_catalog/distribution_periods/PublisherContextSwitcher';

interface PublisherScopedListTitleProps {
  title: string;
  /** Matching-row count for the current filters; hidden until known. */
  total?: number;
  /** Translation key for the count line, interpolating `{{total}}`. */
  totalKey: string;
  publisherId: number | null;
  onPublisherChange: (publisherId: number | null) => void;
}

/** `Title / [publisher ▾]` with the matching-row count beneath. */
export const PublisherScopedListTitle = ({
  title,
  total,
  totalKey,
  publisherId,
  onPublisherChange,
}: PublisherScopedListTitleProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Flex vertical gap={token.marginXXS}>
      <Flex align="center" gap={token.marginSM} wrap>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        <Typography.Text
          type="secondary"
          style={{ fontSize: token.fontSizeHeading3 }}
        >
          /
        </Typography.Text>
        <PublisherContextSwitcher
          value={publisherId}
          onChange={onPublisherChange}
        />
      </Flex>
      {total != null && (
        <Typography.Text type="secondary" style={{ fontWeight: 'normal' }}>
          {t(totalKey, { total })}
        </Typography.Text>
      )}
    </Flex>
  );
};
